function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_27",
  "data-name": "Rectangle 27",
  width: 76,
  height: 71,
  transform: "translate(0)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 0.7
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-2"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_24",
  "data-name": "Rectangle 24",
  width: 75.15,
  height: 69.655,
  fill: "none",
  stroke: "#707070",
  strokeWidth: 0.7
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-4"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_26",
  "data-name": "Rectangle 26",
  width: 28.808,
  height: 21.626,
  fill: "#cc6a2f",
  stroke: "#707070",
  strokeWidth: 0.7
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_61",
  "data-name": "Group 61",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_56",
  "data-name": "Group 56",
  transform: "translate(0.425 0.426)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_55",
  "data-name": "Group 55",
  clipPath: "url(#clip-path-2)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_54",
  "data-name": "Group 54"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_53",
  "data-name": "Group 53",
  clipPath: "url(#clip-path-2)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_143",
  "data-name": "Path 143",
  d: "M76.466,20.79a18.076,18.076,0,0,1,.085,6,37.607,37.607,0,0,1-1.037,5.264c-.323,1.022-.632,2.049-1.008,3.053-.617,1.64-1.178,3.3-1.929,4.9A33.017,33.017,0,0,1,68.2,47.139a81.9,81.9,0,0,1-7.435,8.133c-2.807,2.583-5.582,5.213-8.63,7.538-1.932,1.476-4.036,2.753-6,4.194-.635.465-1.311.874-1.9,1.4a15.288,15.288,0,0,1-4.773,2.758c-.906.355-1.835-.244-2.617-.709-1.609-.959-3.062-2.14-4.605-3.2-3.062-2.094-5.9-4.447-8.857-6.675-1.728-1.305-3.3-2.787-5-4.121a43.468,43.468,0,0,1-6.333-6.527,52.232,52.232,0,0,1-4.71-6.462A31.771,31.771,0,0,1,3.92,36.231c-.5-1.669-1.1-3.329-1.518-5.017a18.916,18.916,0,0,1-.753-6.07c.062-.832-.006-1.674-.02-2.509a19.433,19.433,0,0,1,1.8-7.946C5,10.973,7.854,8.257,10.981,5.834A17.79,17.79,0,0,1,18.8,2.2a18.229,18.229,0,0,1,7.353.029,20.151,20.151,0,0,1,10.76,6.538c.408.451,1,2.009,1.637,2.866a6.515,6.515,0,0,1,.719-1.743c1.4-2.421,3.719-3.669,6.149-5.108A24.052,24.052,0,0,1,53.207,1.79a18.4,18.4,0,0,1,5.194.034A17,17,0,0,1,67.207,5c1.94,1.447,4.1,2.71,5.342,4.87a32.638,32.638,0,0,1,2.572,5.514,33.637,33.637,0,0,1,1.346,5.4m-3.387,8.094a16.255,16.255,0,0,0,.328-3.454c-.031-.579-.142-3.394-.286-4.2-.181-1.016-.626-2-.833-3.011-.476-2.336-1.988-4.177-3.238-6.141A15.664,15.664,0,0,0,65.06,8.249,11.5,11.5,0,0,0,61.506,6.01a32.924,32.924,0,0,1-3.359-.579,17.2,17.2,0,0,0-7.016.579C43.875,9.424,45.3,8.842,43.9,10.227a27.622,27.622,0,0,0-3.77,4.6c-.487.579-.549,1.538-1.28,1.288-.527-.181-1.841-2.574-2.164-2.994a32.4,32.4,0,0,0-3.642-4.152c-2.356-1.862-3.155-2.554-6.075-3.048a17.578,17.578,0,0,0-7.749.213,24.073,24.073,0,0,0-6.356,3.09,16.937,16.937,0,0,0-5.007,5.105,15.2,15.2,0,0,0-1.966,4.572,26.917,26.917,0,0,0-.878,4.342c-.156,1.132-.008,2.27-.263,3.386l-.051.375c.133.832.38,1.643.544,2.475a24.551,24.551,0,0,0,1.294,5.253c.36.826.654,1.674,1.073,2.472,1.042,2,1.776,4.129,3.246,5.942,1.892,2.338,3.648,4.762,5.707,6.993,1.2,1.3,2.5,2.517,3.727,3.789a38.986,38.986,0,0,0,4.7,3.936c2.736,2.046,5.7,3.78,8.618,5.585a23.9,23.9,0,0,0,3.577,2.128c.918.372,2.283,1.356,3.1.63a5.865,5.865,0,0,1,1.2-.715c1.235-.554,3.518-2.3,4.713-2.929,2.809-1.467,3.515-2.8,5.925-4.739q4.342-3.5,8.42-7.273A48.921,48.921,0,0,0,69.5,39.625a22.96,22.96,0,0,0,2.773-6.388c.34-1.442.572-2.9.81-4.353",
  transform: "translate(-1.612 -1.612)",
  fill: "#a0a0a0",
  stroke: "#707070",
  strokeWidth: 0.7
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_144",
  "data-name": "Path 144",
  d: "M82.022,35.613a16.255,16.255,0,0,1-.328,3.454c-.238,1.456-.47,2.912-.81,4.353a22.964,22.964,0,0,1-2.773,6.388,48.921,48.921,0,0,1-8.95,10.929q-4.066,3.772-8.421,7.273c-2.41,1.944-3.115,3.272-5.925,4.739-1.2.624-3.478,2.375-4.713,2.929a5.865,5.865,0,0,0-1.2.715c-.821.727-2.186-.258-3.1-.63a23.882,23.882,0,0,1-3.577-2.128c-2.914-1.8-5.883-3.539-8.618-5.585a39.011,39.011,0,0,1-4.7-3.936c-1.232-1.271-2.529-2.486-3.727-3.789-2.059-2.231-3.815-4.654-5.707-6.993-1.47-1.813-2.2-3.945-3.246-5.942-.419-.8-.714-1.646-1.073-2.472a24.551,24.551,0,0,1-1.294-5.253c-.164-.832-.411-1.643-.544-2.474l.051-.375c.255-1.115.108-2.253.264-3.386a26.917,26.917,0,0,1,.878-4.342,15.2,15.2,0,0,1,1.966-4.572,16.94,16.94,0,0,1,5.007-5.105,24.081,24.081,0,0,1,6.356-3.09,17.579,17.579,0,0,1,7.749-.213c2.92.494,3.719,1.186,6.075,3.048A32.4,32.4,0,0,1,45.3,23.308c.323.42,1.637,2.812,2.164,2.994.731.25.793-.709,1.28-1.288a27.607,27.607,0,0,1,3.77-4.6c1.4-1.385-.023-.8,7.233-4.217a17.2,17.2,0,0,1,7.016-.579,32.923,32.923,0,0,0,3.359.579,11.5,11.5,0,0,1,3.554,2.239,15.664,15.664,0,0,1,3.991,3.831c1.249,1.964,2.761,3.806,3.237,6.141.207,1.007.651,2,.833,3.011.144.8.255,3.618.286,4.2M71.5,51.74a4.224,4.224,0,0,0,.425-2.79,3.206,3.206,0,0,0-6.018-.372,3.285,3.285,0,0,0-.283,2.452c.354,1.175,1.5,2.486,2.524,2.563A3.33,3.33,0,0,0,71.5,51.74m-1.5-16.474a.22.22,0,0,0-.108-.25c-.595-.352-1.275-.136-1.889-.273-1.107-.25-1.677.312-2.153,1.166-.966,1.737-2.084,3.386-3.008,5.154-.759,1.459-1.685,2.827-2.433,4.3-.592,1.161-1.184,2.333-1.875,3.428-.906,1.445-1.7,2.954-2.614,4.387-.465.724-.292,1.064.566,1.061a10.366,10.366,0,0,0,2.286-.289.965.965,0,0,0,.73-.48c.388-.76.921-1.453,1.26-2.233a61.359,61.359,0,0,1,3.481-6.6,16.193,16.193,0,0,0,1.028-1.706,34.467,34.467,0,0,1,3.076-5.086,13.234,13.234,0,0,0,1.651-2.5Zm-8.8,4.368a3.765,3.765,0,0,0-1.782-5.585h-.071c-.609-.008-1.181-.349-1.787-.278a3.182,3.182,0,0,0-2.532,2.015,3.958,3.958,0,0,0-.241,3.2c.666,1.518,2.09,3.173,4.28,2.528a3.637,3.637,0,0,0,2.133-1.879",
  transform: "translate(-10.227 -11.795)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 0.7
}), /*#__PURE__*/React.createElement("path", {
  className: "il-primary",
  id: "Path_145",
  "data-name": "Path 145",
  d: "M217.7,135.817a4.226,4.226,0,0,1-.425,2.79,3.33,3.33,0,0,1-3.354,1.853c-1.022-.077-2.169-1.388-2.523-2.563a3.283,3.283,0,0,1,.283-2.452,3.206,3.206,0,0,1,6.019.372m-2.923,2.14a1.5,1.5,0,0,0,.717-1.283.916.916,0,0,0-.651-.834.873.873,0,0,0-1.212.854l.006.125c-.065.57.405.811.725,1.135.071.071.283.043.416,0",
  transform: "translate(-156.001 -98.662)",
  fill: "#cc6a2f",
  stroke: "#707070",
  strokeWidth: 0.7
}), /*#__PURE__*/React.createElement("path", {
  className: "il-primary",
  id: "Path_146",
  "data-name": "Path 146",
  d: "M188.242,88.6a.22.22,0,0,1,.108.25v.071a13.232,13.232,0,0,1-1.651,2.5,34.469,34.469,0,0,0-3.076,5.086,16.154,16.154,0,0,1-1.028,1.706,61.354,61.354,0,0,0-3.481,6.6c-.34.78-.872,1.473-1.26,2.233a.965.965,0,0,1-.731.48,10.363,10.363,0,0,1-2.286.289c-.858,0-1.031-.338-.566-1.062.918-1.433,1.708-2.943,2.614-4.387.691-1.1,1.283-2.268,1.875-3.428.748-1.47,1.674-2.838,2.433-4.3.923-1.768,2.042-3.417,3.008-5.154.476-.854,1.045-1.416,2.152-1.166.615.136,1.294-.08,1.889.272",
  transform: "translate(-128.569 -65.378)",
  fill: "#cc6a2f",
  stroke: "#707070",
  strokeWidth: 0.7
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_147",
  "data-name": "Path 147",
  d: "M222.088,143.066a1.5,1.5,0,0,1-.717,1.283c-.133.04-.346.068-.417,0-.32-.323-.79-.565-.725-1.135l-.006-.125a.873.873,0,0,1,1.212-.854.917.917,0,0,1,.651.834",
  transform: "translate(-162.594 -105.054)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 0.7
}), /*#__PURE__*/React.createElement("path", {
  className: "il-primary",
  id: "Path_148",
  "data-name": "Path 148",
  d: "M174.623,85.059a3.765,3.765,0,0,1,1.782,5.585,3.637,3.637,0,0,1-2.133,1.879c-2.189.644-3.614-1.01-4.28-2.528a3.958,3.958,0,0,1,.241-3.2,3.182,3.182,0,0,1,2.532-2.015c.606-.071,1.178.27,1.787.278Zm-.64,4.876a1.7,1.7,0,0,0,.479-1.507.919.919,0,0,0-.983-.863h-.071c-.564.182-1.039.426-1.005,1.146a1.48,1.48,0,0,0,1,1.3.479.479,0,0,0,.578-.074",
  transform: "translate(-125.424 -62.805)",
  fill: "#cc6a2f",
  stroke: "#707070",
  strokeWidth: 0.7
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_149",
  "data-name": "Path 149",
  d: "M181.872,96.211a1.7,1.7,0,0,1-.479,1.507.478.478,0,0,1-.578.074,1.48,1.48,0,0,1-1-1.3c-.034-.721.442-.965,1.005-1.146h.071a.919.919,0,0,1,.983.863",
  transform: "translate(-132.835 -70.588)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 0.7
}))))), /*#__PURE__*/React.createElement("path", {
  id: "Path_150",
  "data-name": "Path 150",
  d: "M188.349,88.92a13.232,13.232,0,0,1-1.651,2.5,34.49,34.49,0,0,0-3.076,5.086,16.2,16.2,0,0,1-1.028,1.706,61.31,61.31,0,0,0-3.481,6.6c-.34.78-.873,1.473-1.26,2.233a.965.965,0,0,1-.731.48,10.366,10.366,0,0,1-2.286.289c-.858,0-1.031-.338-.566-1.062.918-1.433,1.708-2.943,2.614-4.387.691-1.1,1.283-2.268,1.875-3.428.748-1.47,1.674-2.838,2.433-4.3.923-1.768,2.042-3.417,3.008-5.154.476-.854,1.045-1.416,2.153-1.166.614.136,1.294-.08,1.889.272a.22.22,0,0,1,.108.25",
  transform: "translate(-128.144 -64.952)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.7
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_151",
  "data-name": "Path 151",
  d: "M217.277,138.608a4.226,4.226,0,0,0,.425-2.79,3.206,3.206,0,0,0-6.019-.372,3.284,3.284,0,0,0-.283,2.452c.354,1.175,1.5,2.486,2.523,2.563A3.33,3.33,0,0,0,217.277,138.608Z",
  transform: "translate(-155.576 -98.237)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.7
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_152",
  "data-name": "Path 152",
  d: "M174.552,85.059c-.609-.008-1.181-.349-1.787-.278a3.182,3.182,0,0,0-2.532,2.015,3.955,3.955,0,0,0-.241,3.2c.665,1.518,2.09,3.173,4.279,2.529a3.636,3.636,0,0,0,2.133-1.879,3.765,3.765,0,0,0-1.781-5.585",
  transform: "translate(-124.999 -62.38)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.7
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_153",
  "data-name": "Path 153",
  d: "M220.23,143.211c-.065.571.4.812.725,1.135.071.071.283.043.417,0a1.5,1.5,0,0,0,.717-1.283.917.917,0,0,0-.651-.834.873.873,0,0,0-1.212.854",
  transform: "translate(-162.169 -104.628)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.7
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_154",
  "data-name": "Path 154",
  d: "M180.819,95.348c-.564.182-1.039.426-1.005,1.146a1.48,1.48,0,0,0,1,1.3.479.479,0,0,0,.578-.074,1.7,1.7,0,0,0,.479-1.507.919.919,0,0,0-.983-.863",
  transform: "translate(-132.41 -70.163)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.7
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_155",
  "data-name": "Path 155",
  d: "M76.465,20.79a18.069,18.069,0,0,1,.085,6,37.607,37.607,0,0,1-1.037,5.264c-.323,1.022-.632,2.049-1.008,3.053-.617,1.64-1.178,3.3-1.929,4.9A33.027,33.027,0,0,1,68.2,47.14a81.934,81.934,0,0,1-7.435,8.133c-2.807,2.583-5.582,5.213-8.63,7.537-1.932,1.476-4.036,2.753-6,4.194-.634.465-1.311.874-1.9,1.4a15.287,15.287,0,0,1-4.772,2.758c-.906.355-1.835-.244-2.617-.709-1.609-.959-3.062-2.14-4.605-3.2-3.062-2.094-5.9-4.447-8.857-6.675-1.727-1.306-3.3-2.787-5-4.121a43.484,43.484,0,0,1-6.333-6.527,52.2,52.2,0,0,1-4.71-6.462,31.743,31.743,0,0,1-3.419-7.239c-.5-1.669-1.1-3.329-1.518-5.017a18.915,18.915,0,0,1-.753-6.07c.062-.832-.006-1.674-.02-2.509a19.435,19.435,0,0,1,1.8-7.946C5,10.974,7.853,8.258,10.98,5.834A17.787,17.787,0,0,1,18.8,2.2a18.229,18.229,0,0,1,7.353.028,20.155,20.155,0,0,1,10.76,6.539c.408.451,1,2.009,1.637,2.866a6.5,6.5,0,0,1,.719-1.743c1.4-2.421,3.719-3.669,6.149-5.108A24.052,24.052,0,0,1,53.206,1.79a18.414,18.414,0,0,1,5.194.034A17,17,0,0,1,67.206,5c1.94,1.448,4.1,2.71,5.341,4.87a32.626,32.626,0,0,1,2.572,5.514A33.645,33.645,0,0,1,76.465,20.79Z",
  transform: "translate(-1.186 -1.187)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.7
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_156",
  "data-name": "Path 156",
  d: "M13.362,36.815c.255-1.115.108-2.253.263-3.386a26.94,26.94,0,0,1,.878-4.342,15.2,15.2,0,0,1,1.966-4.572,16.946,16.946,0,0,1,5.007-5.105,24.077,24.077,0,0,1,6.356-3.09,17.575,17.575,0,0,1,7.749-.213c2.92.494,3.719,1.186,6.075,3.048A32.4,32.4,0,0,1,45.3,23.307c.323.42,1.637,2.812,2.164,2.994.731.25.793-.709,1.28-1.288a27.611,27.611,0,0,1,3.77-4.6c1.4-1.385-.023-.8,7.234-4.217a17.2,17.2,0,0,1,7.015-.579,32.923,32.923,0,0,0,3.359.579,11.505,11.505,0,0,1,3.555,2.239,15.668,15.668,0,0,1,3.991,3.831c1.249,1.964,2.761,3.806,3.237,6.141.207,1.007.651,2,.833,3.011.144.8.255,3.618.286,4.2a16.256,16.256,0,0,1-.329,3.454c-.238,1.456-.47,2.912-.81,4.353a22.967,22.967,0,0,1-2.773,6.388,48.915,48.915,0,0,1-8.95,10.929q-4.066,3.772-8.42,7.274c-2.41,1.944-3.115,3.272-5.925,4.739-1.2.624-3.478,2.375-4.713,2.929a5.886,5.886,0,0,0-1.2.715c-.821.726-2.186-.258-3.1-.63a23.9,23.9,0,0,1-3.577-2.128c-2.914-1.8-5.883-3.539-8.618-5.585a38.987,38.987,0,0,1-4.7-3.936c-1.232-1.271-2.529-2.486-3.727-3.789-2.059-2.23-3.815-4.654-5.707-6.992-1.47-1.813-2.2-3.945-3.246-5.943-.419-.8-.714-1.646-1.073-2.472a24.564,24.564,0,0,1-1.294-5.253c-.164-.832-.41-1.643-.544-2.475",
  transform: "translate(-9.802 -11.369)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "bevel",
  strokeWidth: 0.7
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_60",
  "data-name": "Group 60",
  transform: "translate(13.64 20.328)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_59",
  "data-name": "Group 59",
  clipPath: "url(#clip-path-4)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_58",
  "data-name": "Group 58"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_57",
  "data-name": "Group 57",
  clipPath: "url(#clip-path-4)"
}, /*#__PURE__*/React.createElement("path", {
  className: "il-primary",
  id: "Path_157",
  "data-name": "Path 157",
  d: "M122.55,82.012a7.07,7.07,0,0,1,.09,4.3,21.449,21.449,0,0,1-2.191,5.73c-.605,1.068-1.324,2.072-1.963,3.125-.752,1.237-1.728,2.326-2.4,3.61a1.255,1.255,0,0,1-1.421.627c-1.138-.1-3.049-.5-4.169-.205a.988.988,0,0,1,.295-.914,41.8,41.8,0,0,0,3.094-5.531c.439-.838.376-1.071-.424-1.55-2.011-1.206-3.251-2.051-4.033-5.169a2.662,2.662,0,0,1,.024-1.7c.184-.844.247-1.442.482-2.175a6.125,6.125,0,0,1,2.757-2.989,6.549,6.549,0,0,1,6.14-.57,6.144,6.144,0,0,1,3.717,3.405m-4.915,3.529-.072-.072a2.2,2.2,0,0,0-.265-1.5,1.616,1.616,0,0,0-2.42-.127,2.176,2.176,0,0,0,1.059,3.112,1.394,1.394,0,0,0,1.412-.781c.114-.2.19-.422.286-.633",
  transform: "translate(-94.123 -77.797)",
  fill: "#cc6a2f",
  stroke: "#707070",
  strokeWidth: 0.7
}), /*#__PURE__*/React.createElement("path", {
  className: "il-primary",
  id: "Path_158",
  "data-name": "Path 158",
  d: "M64.86,80.87a7.092,7.092,0,0,1,.09,4.3,21.538,21.538,0,0,1-2.191,5.73c-.608,1.068-1.327,2.072-1.962,3.125-.753,1.237-1.728,2.326-2.4,3.61a1.255,1.255,0,0,1-1.421.627,13.848,13.848,0,0,0-4.009.148l-.159-.353a.987.987,0,0,1,.295-.914,42.136,42.136,0,0,0,3.091-5.531c.442-.838.379-1.071-.422-1.55-2.011-1.206-2.61-1.36-3.5-3.441a11.165,11.165,0,0,1-.509-3.426c.181-.844.545-1.74.78-2.476A4.949,4.949,0,0,1,55,78.035a6.549,6.549,0,0,1,6.14-.57A6.153,6.153,0,0,1,64.86,80.87M59.942,84.4l-.069-.072a2.185,2.185,0,0,0-.268-1.5,1.612,1.612,0,0,0-2.417-.127,2.176,2.176,0,0,0,1.059,3.112,1.394,1.394,0,0,0,1.412-.781c.111-.2.19-.422.283-.633",
  transform: "translate(-51.741 -76.957)",
  fill: "#cc6a2f",
  stroke: "#707070",
  strokeWidth: 0.7
}))))), /*#__PURE__*/React.createElement("path", {
  id: "Path_159",
  "data-name": "Path 159",
  d: "M110.5,99.2a.988.988,0,0,1,.295-.914,41.811,41.811,0,0,0,3.094-5.531c.439-.838.376-1.071-.424-1.55-2.011-1.206-3.251-2.051-4.033-5.169a2.662,2.662,0,0,1,.024-1.7,22.251,22.251,0,0,1,.482-2.175,6.124,6.124,0,0,1,2.757-2.989,6.549,6.549,0,0,1,6.14-.57,6.145,6.145,0,0,1,3.717,3.405,7.07,7.07,0,0,1,.09,4.3,21.449,21.449,0,0,1-2.191,5.73c-.605,1.068-1.324,2.072-1.963,3.125-.752,1.237-1.728,2.325-2.4,3.61a1.254,1.254,0,0,1-1.421.627C113.53,99.309,111.618,98.91,110.5,99.2Z",
  transform: "translate(-80.483 -57.47)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.7
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_160",
  "data-name": "Path 160",
  d: "M132.274,100.111a2.2,2.2,0,0,0-.265-1.5,1.616,1.616,0,0,0-2.42-.127,2.176,2.176,0,0,0,1.059,3.112,1.394,1.394,0,0,0,1.412-.781c.114-.2.19-.422.286-.633",
  transform: "translate(-95.195 -72.112)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.7
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_161",
  "data-name": "Path 161",
  d: "M52.808,98.061a.988.988,0,0,1,.295-.914,42.092,42.092,0,0,0,3.091-5.531c.443-.838.379-1.071-.421-1.55-2.011-1.206-2.61-1.36-3.5-3.441a11.165,11.165,0,0,1-.509-3.426c.181-.844.545-1.74.78-2.476A4.949,4.949,0,0,1,55,78.035a6.549,6.549,0,0,1,6.14-.57A6.153,6.153,0,0,1,64.86,80.87a7.092,7.092,0,0,1,.09,4.3,21.548,21.548,0,0,1-2.191,5.73c-.608,1.068-1.328,2.072-1.963,3.125-.752,1.237-1.728,2.325-2.4,3.61a1.254,1.254,0,0,1-1.421.627,13.859,13.859,0,0,0-4.009.148",
  transform: "translate(-38.102 -56.629)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.7
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_162",
  "data-name": "Path 162",
  d: "M74.2,98.969a2.188,2.188,0,0,0-.268-1.5,1.612,1.612,0,0,0-2.417-.127,2.176,2.176,0,0,0,1.059,3.112,1.394,1.394,0,0,0,1.412-.781c.112-.2.19-.422.283-.633",
  transform: "translate(-52.432 -71.272)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.7
}));

var Svg99Vi = function Svg99Vi(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "recomendacion_VI",
    width: 76,
    height: 71,
    viewBox: "0 0 76 71",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg99Vi, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/99_VI.5a79d8a8.svg";
export { ForwardRef as ReactComponent };